var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-marker',{attrs:{"lat-lng":_vm.device.Geometry.Coordinates}},[_c('l-icon',{attrs:{"icon-url":_vm.iconUrl}}),_c('Popup',{attrs:{"device":_vm.device}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }